import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext/AuthContext";
import useIsMember from "../../../hooks/useIsMember";
import AccessDenied from "../AccessDenied/AcessDenied";
const ProtectedRoute = ({ children, groupId = null, channelId = null }) => {
  const { userData, isLoadingUserData } = useAuth();
  const userEmail = userData?.user?.email;
  const { isMember, loading: memberLoading, error: memberError } = useIsMember(groupId, userEmail, channelId);
  const location = useLocation();

  // Exibir carregamento enquanto verifica permissões
  if (isLoadingUserData || memberLoading) {
    return <p>Verificando permissões...</p>;
  }

  // Mostrar erro caso exista
  if (memberError) {
    console.error("Erro ao verificar membros:", memberError);
    return <p>Erro ao carregar permissões. Tente novamente.</p>;
  }

  // Renderizar componente de acesso negado se o usuário não for membro
  if ((groupId || channelId) && !isMember) {
    return <AccessDenied />;
  }

  // Renderizar rota protegida se tudo estiver correto
  return children;
};

export default ProtectedRoute;
